module.exports = __webpack_public_path__ + "assets/7c10af124b719b69118ed7b1366ba0bb.mp3";